import { Inter } from "next/font/google";
import classNames from "classnames";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

export const TopPlaceDescription = ({ description }) => {
    if (!description) {
        return null;
    }
    
    return (
        <p
            id="top-place-description"
            onClick={() => trackItemTapped(MixpanelValues.ItemTapped.BLURB)}
            className={classNames(
                inter.className,
                "text-sky-950 text-[15px] font-semibold leading-snug mb-2"
            )}>
            {description}
        </p>
    );
};
